// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"41":"error","321":"core","486":"information","818":"auth","860":"menu"}[chunkId] || chunkId) + "." + {"41":"df790914","227":"1c703c99","321":"17140432","486":"168f0402","678":"40f664e4","818":"ce279163","860":"6a8c298f"}[chunkId] + ".js";
};